/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import { SetStockAdjustmentList, GetStockAdjustmentList } from "../../store/stockAdjustmentAtom";
import CurrencyFormat from "react-currency-format";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { stockService } from "../../services/stockService";
import { formatCustomDate } from "../../helpers/formatCustomDate";

const StockAdjustmentMainPage = () => {
  const { pathname } = useLocation();
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext); // Select only needed context value
 
  const setStockData  = SetStockAdjustmentList();
  const getStockData  = GetStockAdjustmentList();
  const myPromiseModal = createModal(GeneralModal);
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const [searchText, setSearchText] = useState("");
  

  // Memoized columns to prevent recreation
  const columns = useMemo(
    () => [
      {
        title: "Ref",
        key: "ref_no",
        dataIndex: "ref_no",
        className: "text-primary",
        sorter: (a, b) => (a?.ref_no ?? "") - (b?.ref_no ?? ""),
      },
      {
        title: "No.",
        dataIndex: "adjustment_number",
        sorter: (a, b) => (a?.adjustment_number ?? "").localeCompare(b?.adjustment_number ?? ""),
      },
      {
        title: "Date",
        dataIndex: "adjustment_date_string",
        sorter: (a, b) => (a?.adjustment_date_string ?? "").localeCompare(b?.adjustment_date_string ?? ""),
      },
      {
        title: "Warehouse",
        dataIndex: "warehouse_name",
        sorter: (a, b) => (a?.warehouse_name ?? "").localeCompare(b?.warehouse_name ?? ""),
      },

  
      {
        title: "Create Date",
        dataIndex: "encoded_date",
        sorter: (a, b) => (a?.encoded_date ?? 0) - (b?.encoded_date ?? 0),
        render: (record) => <span>{formatCustomDate(record)}</span>,
      },
      {
        title: "Created By",
        dataIndex: "encoded_by_name",
        sorter: (a, b) => (a?.encoded_by_name ?? "").localeCompare(b?.encoded_by_name ?? ""),
      },
      {
        title: "Status",
        dataIndex: "status_name",
        sorter: (a, b) => (a?.status_name ?? "").localeCompare(b?.status_name ?? ""),
      },
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    if (getStockData?.Stock_Adjustment_Info?.length > 0) {
      setTableData(getStockData?.Stock_Adjustment_Info || []);
    }else{
      getStockListFromAPI();
    }
    return () => {
    };
  }, []);


  // Handle session-based reload
  useEffect(() => {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getStockListFromAPI();
    }
  }, []);


  // Fetch sales order list with abortable request
  const getStockListFromAPI = useCallback(async () => {
   
    try {
      const response = await stockService.stockAdjustmentList();
      const serverData =  response.data
      if ( response?.data !== undefined) {
        const Stock_Adjustment_Info = serverData?.Stock_Adjustment_Info?.length ?  serverData?.Stock_Adjustment_Info : [];
        const Warehouse = serverData?.Warehouse?.length ?  serverData?.Warehouse : [];
        setStockData({...serverData, Stock_Adjustment_Info: Stock_Adjustment_Info, Warehouse:Warehouse });
      setTableData(response.data?.Stock_Adjustment_Info || []);

      }
    } catch (err) {
        console.error(err);
    }
   
  }, [setStockData]);





  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);

  const addNewInvoice = useCallback(() => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }, [currModuleId, currModuleName, currUserMenu, navigate]);


  const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await stockService.stockAdjustmentListByDate(formData);
      if (response?.data?.length) {
        setTableData(response.data);
      } else {
        showToast("No result found", "");
        setTableData([]);
      }
    } catch (err) {
      showToast("Error", "error");
    }
  }, [getValues, showToast]);

  const handleRowClick = useCallback(
    (data) => {
      const id = data["ref_no"];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );



  const onClearInput = ()=> {
    setSearchText("");
    setTableData(getStockData?.Stock_Adjustment_Info || []);

   }



  const handleSearch = (text) => {
    setSearchText(text);
   
     if (text.trim() === "") {
      setTableData(getStockData?.Stock_Adjustment_Info || []);
       return;
     }
   
     const searchTerm = text.toLowerCase();
     const filtered = (getStockData?.Stock_Adjustment_Info || []).filter(credit =>
       Object.values(credit).some(value => 
         value?.toString().toLowerCase().includes(searchTerm)
       )
     );
     setTableData(filtered); 
   };

  return (
    <>
  
      <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">
        <div className="flex items-center space-x-2">
          {/* {itemSelected.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Bulk Actions</Dropdown.Toggle>
              <Dropdown.Menu>
                {salesOrderData["Bulk_Action"]?.map((action, i) => (
                  <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                    {action.Action_Name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <SalesOrderFilter list={salesOrderData["Filtering_Criteria"]} onFilterSelect={onFilterSelect} />
          )} */}
          <Tooltip title="Reload">
            <div
              onClick={getStockListFromAPI}
              className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
            >
              <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
            </div>
          </Tooltip>
        </div>

        <div className="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm">From Date:</span>
            <input
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              {...register("from_date")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <span className="ml-1 text-sm">To Date:</span>
            <input
              {...register("to_date")}
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <button
              onClick={searchByDate}
              type="button"
              className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
            >
              Search
            </button>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <Tooltip title="Add New">
            <button
              onClick={addNewInvoice}
              className="ml-2 h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1.5px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
            >
              <FaPlus className="h-[16px] w-[16px] text-gray-600" />
            </button>
          </Tooltip>
        </div>

      </div>

                  {/* Start of search */}
    <div className="flex justify-center mt-4">
    <div className="flex flex-col w-full md:w-1/3">
      <input
        type="text"
        placeholder="Search in table"
        value={searchText}
        onKeyDown={(e) => {
          if (e.key === 'Backspace') {
            onClearInput();
          }
        }}
        onChange={(e) => handleSearch(e.target.value)}
        className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
      />
    </div>
  </div>
  {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.Sales_Order_Ref_No}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
};

export default React.memo(StockAdjustmentMainPage); // Memoize component